export default "__VITE_ASSET__J9HX_3oT__"